import { html } from 'lit';
const PlanetPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M4.956 15.825c1.723 3.169 5.435 4.874 9.061 3.903 3.626-.972 5.988-4.305 5.895-7.91-.302.168-.625.332-.96.49-1.62.769-3.855 1.563-6.327 2.225s-4.804 1.092-6.592 1.237q-.555.046-1.077.055M9.876 4.272c3.475-.93 7.028.597 8.834 3.514.473.001.894.035 1.235.113.211.048.425.12.608.235.186.117.378.305.454.587.091.34-.032.644-.169.852-.138.21-.337.402-.556.575-.441.35-1.079.714-1.843 1.076-1.538.729-3.7 1.5-6.124 2.15-2.425.65-4.683 1.062-6.38 1.2-.842.069-1.577.072-2.134-.01a2.6 2.6 0 0 1-.769-.22c-.222-.112-.48-.313-.572-.653a1 1 0 0 1 .1-.736c.1-.19.25-.36.409-.507.256-.238.603-.478 1.013-.716.105-3.43 2.419-6.529 5.894-7.46"/>
  </svg>
`;
export default PlanetPanel;
